import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import { onAuthStateChanged } from 'firebase/auth'
import firebaseService from '../firebase'
import Raphael from 'raphael/raphael'
import 'mutationobserver-shim'
import './plugins'
import './registerServiceWorker'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueFlatPickr from 'vue-flatpickr-component'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import _ from 'lodash'
import { createMainStore } from './shoppingCart'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives
})

global.Raphael = Raphael


configureCompat({
  MODE: 2
})

let app

onAuthStateChanged(firebaseService.firebaseAuth, (user) => {
  const userId = user ? user.uid : 'vuex'
  const mainStore = createMainStore(userId)

  if (!app) {
    app = createApp(App)
      .use(router)
      .use(BootstrapVue)
      .use(BootstrapVueIcons)
      .use(VueFlatPickr)
      .use(ElementPlus)
      .use(vuetify)
      .use(mainStore)
      .use(Toast, { transition: 'Vue-Toastification__fade', maxToasts: 5 })
    const components = require.context('./components/xray')
    _.forEach(components.keys(), (fileName) => {
      const componentConfig = components(fileName)
      const componentName = fileName.split('/').pop().split('.')[0]
      app.component(componentName, componentConfig.default || componentConfig)
    })

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
      app.component(key, component)
    }

    app.mount('#app')
  } else {
    app.use(mainStore)
  }
})
